import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, compose, branch, renderNothing, withHandlers, lifecycle } from 'recompose'

import Avatar from 'shared-web/src/components/Avatar'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import { selectedWidgetFont } from 'app/modules/embed/selectors'
import { loadMissingFonts } from 'utils/fonts'

import EmailCaptureMessage from './component'

const mapStateToProps = state => ({
  orgUsers: UserSelectors.currentOrgUsersAlphabetical(state),
  emailCaptureMessage: PlaybookSelectors.emailCaptureMessage(state),
  selectedFont: selectedWidgetFont(state) || 'Brandon'
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setMessage: PlaybookActions.setMessage,
      setHeadline: PlaybookActions.setHeadline,
      setAuthorId: PlaybookActions.setAuthorId,
      setThankYouMessage: PlaybookActions.setThankYouMessage,
      setThankYouHeadline: PlaybookActions.setThankYouHeadline,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(({ orgUsers }) => !orgUsers.size, renderNothing),
  withProps(props => ({
    userObjForAuthor: props.orgUsers
      .toJS()
      .find(user => user.id === props.emailCaptureMessage.authorId),
  })),
  lifecycle({
    componentDidMount() {
      loadMissingFonts()
    }
  }),
  withProps(props => ({
    message: props.emailCaptureMessage.message,
    headline: props.emailCaptureMessage.title,
    thankYouMessage: props.emailCaptureMessage.thankYouMessage,
    thankYouHeadline: props.emailCaptureMessage.thankYouHeadline,
    selectedUser: props.userObjForAuthor || props.orgUsers.first().toJS(),
    selectedFont: props.selectedFont
  })),
  withHandlers({
    onMessageChange: props => message => {
      props.actions.setMessage(message)
    },
    onHeadlineChange: props => event => {
      props.actions.setHeadline({ value: event.target.value })
    },
    onThankYouMessageChange: props => message => {
      props.actions.setThankYouMessage(message)
    },
    onThankYouHeadlineChange: props => event => {
      props.actions.setThankYouHeadline(event.target.value)
    },
    onAuthorChange: props => ({ value }) => {
      props.actions.setAuthorId(value)
    },
  })
)(EmailCaptureMessage)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailCaptureMessage/index.js